export const Routing = {
    transportOrders: '/transport-orders',
    warehouseSelection: '/warehouse-selection',
    carrierView: '/carrier',
    auditorView: '/auditor',
    errorPage: '/error',
};
